import { fromDate14DaysEarlier, toDateToday } from 'charts/common';
import { AnalyticsTranslationKeys, CommonTranslationKeys, InspectionTranslationKeys } from 'intl/keys';
import {
  FilterValues,
  DateRangeIntervalWithoutWeek,
} from 'shared/types/analytics';

export function defaultValues(): FilterValues {
  return {
    dataScope: {
      labelId: AnalyticsTranslationKeys.tab,
      filters: [
        {
          labelId: 'data_scope_date_interval',
          value: DateRangeIntervalWithoutWeek.day,
        },
        {
          labelId: AnalyticsTranslationKeys.dateRange,
          value: {
            from: fromDate14DaysEarlier,
            to: toDateToday,
            interval: DateRangeIntervalWithoutWeek.day,
          },
        },
        {
          labelId: CommonTranslationKeys.process,
          value: [],
        },
        {
          labelId: AnalyticsTranslationKeys.sites,
          value: [],
        },
        {
          labelId: InspectionTranslationKeys.tableAuthor,
          value: [],
        },
      ],
    },
  };
}
